import axios from "@/api/axiosInstance";
import { GetAdminUserFormDetailsResponse } from "./types";

export const fetchAdminUserFormDetails = async (
  uuid: string,
): Promise<GetAdminUserFormDetailsResponse> => {
  const response = await axios.get<GetAdminUserFormDetailsResponse>(
    `/api/private/admin/user-form-details/${uuid}`,
  );
  return response.data;
};
